















































import { Program } from "../../data/models/PanelConfig";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class ProgramChooserComponent extends Vue {
  isShowing = false;

  selectedProgramNumber = -1;

  resolve?: (value: Program | undefined) => void = undefined;
  reject?: (reason: string) => void = undefined;

  programs: Array<Program> = [];

  async show(programs: Array<Program>) {
    this.selectedProgramNumber = -1;
    this.programs = programs;
    this.isShowing = true;

    return new Promise<Program | undefined>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  onAccept() {
    this.isShowing = false;
    this.resolve && this.resolve(this.programs[this.selectedProgramNumber - 1]);
  }

  onReject() {
    this.isShowing = false;
    this.resolve && this.resolve(undefined);
  }

  onInput() {
    this.resolve && this.resolve(undefined);
  }
}
